import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import type { NotificationState, ModalState } from '@/types/ui';

interface UIState {
  notifications: NotificationState[];
  modal: ModalState;
  sidebar: {
    isOpen: boolean;
    isCollapsed: boolean;
  };
}

const initialState: UIState = {
  notifications: [],
  modal: {
    isOpen: false,
  },
  sidebar: {
    isOpen: true,
    isCollapsed: false,
  },
};

const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    addNotification: (state, action: PayloadAction<Omit<NotificationState, 'id'>>) => {
      const notification: NotificationState = {
        ...action.payload,
        id: Date.now().toString(),
      };
      state.notifications.push(notification);
    },
    removeNotification: (state, action: PayloadAction<string>) => {
      state.notifications = state.notifications.filter((n) => n.id !== action.payload);
    },
    clearNotifications: (state) => {
      state.notifications = [];
    },
    openModal: (state, action: PayloadAction<Omit<ModalState, 'isOpen'>>) => {
      state.modal = {
        ...action.payload,
        isOpen: true,
      };
    },
    closeModal: (state) => {
      state.modal = {
        isOpen: false,
      };
    },
    toggleSidebar: (state) => {
      state.sidebar.isOpen = !state.sidebar.isOpen;
    },
    collapseSidebar: (state, action: PayloadAction<boolean>) => {
      state.sidebar.isCollapsed = action.payload;
    },
  },
});

export const {
  addNotification,
  removeNotification,
  clearNotifications,
  openModal,
  closeModal,
  toggleSidebar,
  collapseSidebar,
} = uiSlice.actions;

export default uiSlice.reducer;
